import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { EllipsisLabel } from "./styled";

export const LabelTooltip = ({ text, style }: { text: string; style?: React.CSSProperties }) => {
	const ref = useRef<HTMLSpanElement>(null);
	const [pos, setPos] = useState<{ x: number; y: number; maxW: number } | null>(null);

	const handleEnter = () => {
		const el = ref.current;
		if (!el || el.scrollWidth <= el.clientWidth) return;
		const rect = el.getBoundingClientRect();
		const pad = 12;
		const maxW = window.innerWidth - rect.left - pad;
		setPos({ x: rect.left, y: rect.top, maxW: Math.max(maxW, 120) });
	};

	return (
		<>
			<EllipsisLabel ref={ref} style={{ display: "block", minWidth: 0, ...style }} onMouseEnter={handleEnter} onMouseLeave={() => setPos(null)}>
				{text}
			</EllipsisLabel>
			{pos &&
				createPortal(
					<div
						style={{
							position: "fixed",
							left: pos.x,
							top: pos.y - 8,
							transform: "translateY(-100%)",
							maxWidth: pos.maxW,
							background: "#fff",
							color: style?.color ?? "#1a1d26",
							padding: "8px 12px",
							borderRadius: 10,
							boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
							fontSize: 13,
							fontFamily: style?.fontFamily,
							lineHeight: style?.lineHeight,
							whiteSpace: "normal",
							wordBreak: "break-word",
							pointerEvents: "none",
							zIndex: 9999,
						}}>
						{text}
					</div>,
					document.body,
				)}
		</>
	);
};
